import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { vehicleJson } from "../../../DynamicFormsJson/MastersJSON/vehicle";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { getActiveTransporterListByUserTypeUpdated } from "../../../Slice/transporter.slice";
import { serverMsg } from "../../../config/messageconstant";
class ViechleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        transporterDetail: this.props.transporterList?.transporter,
      },
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.transporterList !== nextProps.transporterList) {
      if (
        this.props.transporterList?.transporter !==
        nextProps.transporterList?.transporter
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            transporterDetail: nextProps.transporterList?.transporter,
          },
        });
      }
    }
  }
  async componentDidMount() {
    const { getActiveTransporterListByUserTypeUpdated, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getActiveTransporterListByUserTypeUpdated().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData } = this.state;
    return (
      <>
        <DynamicForm
          formPath={vehicleJson.formPath}
          screenTitle={vehicleJson.screenTitle}
          fieldMeta={vehicleJson.fieldMeta}
          apiBaseURL={vehicleJson.apiBaseURL}
          dynamicMasterData={dynamicMasterData}
          isLog={true}
          type={0}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  transporterList: state.transporter,
  vehicleList: state.vehicle,
});
const mapDispatchToProps = {
  getActiveTransporterListByUserTypeUpdated,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(ViechleForm);
